import React from "react";
import { getIn } from "formik";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

function AutoCompleteField({
	field,
	form,
	label,
	options = [],
	onValueChange,
	isRequired,
	isLoading,
	nooptionText,
	isStoredId = true,
	placeholder,
	...props

}) {
	const [inputValue, setInputValue] = React.useState("");
	const [open, setOpen] = React.useState(false);
	const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);

	const sortedOptions = React.useMemo(() => {
		const seen = new Set();
		return [...options]
			.sort((a, b) => a.label.localeCompare(b.label))
			.filter(option => {
				if (seen.has(option.id)) return false;
				seen.add(option.id);
				return true;
			});
	}, [options]);

	return (
		<FormControl fullWidth error={!!errorText}>
			{field.name && (
				<InputLabel sx={{ ml: -1.6, textTransform: "capitalize" }} shrink htmlFor={field.name}>
					<Typography variant="body1">
						{label}
						{isRequired && (
							<Typography variant="body1" color="error" component="span">
								{" *"}
							</Typography>
						)}
					</Typography>
				</InputLabel>
			)}

			<Autocomplete
				{...props}
				id={field.name}
				inputValue={inputValue}
				// onInputChange={(_, newValue, reason) => {
				// 	setInputValue(newValue);
				// 	if (props.isShow && reason === 'input') {
				// 		setOpen(newValue.length >= 3);
				// 	}

				// 	if (reason === "input") {
				// 		props.onSearchChange?.(newValue);
				// 	}
				// }}

				onInputChange={(_, newValue, reason) => {
					setInputValue(newValue);

					if (props.isShow && reason === "input") {
						setOpen(newValue.length >= 3);
					}

					if (reason === "input") {
						props.onSearchChange?.(newValue);
					}

					if (reason === "clear") {
						props.onSearchChange?.("");     
						props.onClear?.();             
						setInputValue("");
						setOpen(false);
					}
				}}

				open={props.isShow ? open : undefined}
				onOpen={() => {
					if (!props.isShow) setOpen(false);
				}}
				onClose={() => {
					if (props.isShow) setOpen(false);
				}}
				filterOptions={(options, { inputValue }) =>
					options.filter(option => option.label.toLowerCase().includes(inputValue.toLowerCase()))
				}
				options={sortedOptions}
				noOptionsText={nooptionText}
				sx={{
					border: "0.5px solid #DC143C",
					borderRadius: "6px",
					mt: 2,
					"& fieldset": { border: "none" },
					"& .MuiOutlinedInput-root .MuiAutocomplete-input": { padding: "0px 0" },
					"& .MuiAutocomplete-endAdornment": {
						display: props.isShow ? "none !important" : "block !important",
					},

				}}


				onChange={(_, value) => {
					if (value === null) {
						form.setFieldValue(field.name, "");
						setInputValue("");
					} else {
						const storedValue = isStoredId ? value.id : value.value;

						form.setFieldValue(field.name, storedValue);
						onValueChange?.(value);

						setInputValue(""); // 🔥 reset
						setOpen(false);    // 🔥 close dropdown
					}
				}}
				getOptionLabel={(option) => option.value}
				isOptionEqualToValue={(option, val) => option.id === val}
				renderOption={(props, option) => (
					!isLoading ? (
						<li {...props} key={option.id}>
							<Typography variant="body1">{option.value}</Typography>
						</li>
					) : (
						<li>
							<Typography variant="body1">...loading</Typography>
						</li>
					)
				)}
				renderInput={(params) => (
					<TextField
						label={undefined}
						name={field.name}
						placeholder={placeholder}
						{...params}
					/>
				)}
				value={
					isStoredId
						? sortedOptions.find((option) => option.id === field.value) || null
						: sortedOptions.find((option) => option.value === field.value) || null
				}
			/>

			<Typography variant="body2" fontSize={"10px"} color="#DC143C" component="span">
				{errorText}
			</Typography>
		</FormControl>
	);
}


export { AutoCompleteField };
